import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import CompLeaveReqsApproval from '../components/CompLeaveReqsApproval';
import NavBar from '../components/Menu/NavBar'
import { pageStyle } from '../components/UIComponent/CommonStyle'
import { setLocalStorageSettings } from '../components/Function/globalFunction';

const useStyles = makeStyles(() => ({
    ...pageStyle()
}));

export default function CompLeaveApprovalPage({ routing, routingId }) {
    const classes = useStyles();
    setLocalStorageSettings({
        'selectedIndex': 5,
        'isMyRequestOpen': 'false',
        'isApplicationOpen': 'false',
        'isLeaveApprovalOpen': 'true',
        'isHRAdminOpen': 'false'
    });

    return (
        <div className={classes.root}>
            <CssBaseline />
            <NavBar />
            <CompLeaveReqsApproval routing={routing} routingId={routingId} />
        </div>
    )
}